import clsx from 'clsx';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';

const SplitLayout = ({
  isNavActive = true,
  containerClasses,
  leftClasses,
  rightClasses,
  leftContent,
  rightContent,
  children,
  onNavBackClick,
  onNavContinueClick,
  navCurrentStep = 0,
  navTotalSteps = 0,
  isNavNextDisabled = false,
  navBtnText = '',
  navStepperText = 'Volver',
  isNavLoading = false,
  dataTestId = 'user-info-page'
}) => {
  return (
    <>
      <RimacTopBar />
      <div
        data-testid={dataTestId}
        className={clsx('pageContainer', containerClasses)}
      >
        <div
          className={clsx(
            'pageContainer__left',
            'pageContainer__left--new',
            leftClasses
          )}
        >
          {leftContent}
        </div>

        <div
          className={clsx(
            'pageContainer__right',
            'pageContainer__right--new',
            rightClasses
          )}
        >
          {rightContent}
        </div>

        <Navbar
          navActive={isNavActive}
          onBackClick={onNavBackClick}
          onContinueClick={onNavContinueClick}
          currentStep={navCurrentStep}
          totalSteps={navTotalSteps}
          isNextDisabled={isNavNextDisabled}
          btnText={navBtnText}
          isLoading={isNavLoading}
          stepperText={navStepperText}
        />

        {children}
        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default SplitLayout;
